import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../../features/language/LanguageSwitcher';

export function GeneralSettingsPage() {
  const { t } = useTranslation();
  return (
    <section className="settings-section">
      <h2>{t('settings.sections.general')}</h2>
      <p>{t('settings.general.languageDescription')}</p>
      <div className="setting-row">
        <div><strong>{t('settings.general.language')}</strong><small>{t('settings.general.languageDescription')}</small></div>
        <LanguageSwitcher />
      </div>
    </section>
  );
}
